import styled from 'styled-components';
import { DISCLAMERS_COLOR } from '../../config/colors';

const Wrapper = styled.div`
	.pin-label {
		padding-top: 12px;
	}
	.pin-input-wrapper {
		display: flex;
		align-items: center;
		justify-content: space-between;
		> * {
			flex: 1;
			margin: 0 2px;
		}
	}
	h2 {
		padding-top: 12px;
		margin-bottom: 0;
	}
	.description {
		font-size: 10px;
		padding-bottom: 0;
		color: ${DISCLAMERS_COLOR};
	}
	.ant-spin {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(170, 170, 170, 0.5);
		.ant-spin-dot-spin {
			position: absolute;
			top: 50%;
			left: 50%;
			margin-left: -10px;
		}
	}
`;

export default Wrapper;
